import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatNumber } from "@signolteam/shared/units-of-measure";

//metatdata format
let defaultMetadata = {
  draft_aft_m: 6.63,
  draft_mean_m: 6.63,
  od_threshold_m: 7,
  threshold_upper_m: 7.5,
  threshold_lower_m: 6.5,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);

export default function graph({
  bvrColour,
  unit = "m",
  metadata = defaultMetadata,
  missingDataMsg,
  isExample,
}) {
  const actual = Number(metadata["draft_aft_m"] ?? metadata["draft_mean_m"]);
  const threshold = Number(metadata["od_threshold_m"]);
  const thresholdUpper = Number(metadata["threshold_upper_m"]);
  const thresholdLower = Number(metadata["threshold_lower_m"]);

  if (
    isNaN(actual) ||
    isNaN(threshold) ||
    isNaN(thresholdUpper) ||
    isNaN(thresholdLower)
  ) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  const additionalThresholds = [thresholdLower, thresholdUpper];
  const additionalThresholdsActualValues = [``, ``];

  const draftWithinThreshold =
    actual >= thresholdLower && actual <= thresholdUpper;

  const firstBarColour = draftWithinThreshold
    ? bvrColour.codes["500"]
    : bvrColour.codes["200"];
  const data = [
    {
      name: "Actual draft",
      beforeThreshold: actual > thresholdUpper ? thresholdUpper : actual,
      afterThreshold: actual > thresholdUpper ? actual - thresholdUpper : 0,
      underThresholdColour: firstBarColour,
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMax = thresholdUpper > actual ? thresholdUpper + 1 : actual + 1;
  const domainMin = 0;
  const domain = [domainMin, domainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  return (
    <BehaviourBarGraph
      data={data}
      threshold={threshold}
      thresholdLabel={`Instructed draft ${
        !isExample
          ? `(${
              formatNumber(threshold, {
                unit: unit,
                precision: 2,
              }).formattedValue
            })`
          : ""
      }`}
      additionalThresholdsRelative={additionalThresholds}
      additionalThresholdsActualValues={additionalThresholdsActualValues}
      originLabel={`Optimal trim (${threshold} m)`}
      mobileDomain={domain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={draftWithinThreshold}
      unitOfMeasure={` ${unit}`}
      axisLabel={"Draft (m)"}
      hideYLine={true}
      hideNum={true}
      showTicks={false}
      barLabelFormatter={(value) =>
        formatNumber(value, {
          unit: unit,
          precision: 2,
        }).formattedValue
      }
      hideYLabelOnMobile={true}
      isExample={isExample}
    />
  );
}
